module.exports = __webpack_public_path__ + "static/media/absentShiftIcon.b2c62a76.svg";